<div class="close">
  <i-x class="close--icon"></i-x>
</div>
